import { CalendarCheck, Dumbbell, LineChart, MessagesSquare, Target, Video, ArrowRight, UtensilsCrossed } from "lucide-react";
import { CALENDLY_URL, IMAGES } from "../data/content";
import { Reveal } from "../components/Reveal";

const INCLUDES = [
  { icon: Target, title: "Plan 100% individualizado", text: "Entrenamiento y nutrición diseñados para ti: tu punto de partida, tu objetivo, tu vida real." },
  { icon: LineChart, title: "Seguimiento semanal", text: "Revisamos tu progreso cada semana y ajustamos lo que haga falta. Nada queda al azar." },
  { icon: Video, title: "Corrección de técnica", text: "Analizo tus vídeos de entrenamiento para que ejecutes cada ejercicio de forma segura y eficaz." },
  { icon: UtensilsCrossed, title: "Nutrición que se adapta", text: "Ajustes según tu evolución, con opciones para comer en casa o fuera y tu tipo de alimentación." },
  { icon: MessagesSquare, title: "Contacto directo conmigo", text: "Hablas con Dani, no con un bot. Tus dudas, resueltas de verdad." },
  { icon: Dumbbell, title: "Comunidad Team RNB", text: "Acceso a la comunidad privada de WhatsApp con personas que van a por lo mismo que tú." },
];

const STEPS = [
  { num: "01", title: "RESERVA TU LLAMADA", text: "Elige tu hueco en el Calendly 'ACCESO TEAM RNB'. Es el primer paso y no te compromete a nada." },
  { num: "02", title: "HABLAMOS DE TI", text: "Vemos tu punto de partida, tu objetivo y tu contexto: trabajo, estrés, tiempo disponible." },
  { num: "03", title: "EMPEZAMOS A TRABAJAR", text: "Si encajamos, arrancamos con tu plan individualizado y el seguimiento semanal desde el día uno." },
];

export const CalendlyButton = ({ testid, children, className = "" }) => (
  <a
    href={CALENDLY_URL}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testid}
    className={`group inline-flex items-center justify-center gap-3 bg-white text-black font-display text-xl sm:text-2xl tracking-[0.15em] px-8 sm:px-10 py-4 hover:bg-zinc-200 transition-colors ${className}`}
  >
    <CalendarCheck className="h-5 w-5" />
    {children}
    <ArrowRight className="h-5 w-5 transition-transform duration-300 group-hover:translate-x-1" />
  </a>
);

const CoachingVipSection = () => (
  <section id="coaching-vip" data-testid="rnb-vip-section" className="py-20 lg:py-32 bg-[#080808] border-y border-zinc-900">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="text-xs tracking-[0.4em] text-zinc-500 uppercase">Asesoría 1 a 1 · Activa hoy · Plazas limitadas</p>
        <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl text-white leading-[0.95]">
          COACHING <span className="text-transparent" style={{ WebkitTextStroke: "1.5px #fff" }}>VIP 1 A 1</span>
        </h2>
        <p className="mt-5 text-base sm:text-lg text-zinc-400 font-light max-w-2xl mx-auto leading-relaxed">
          Mi método con mi máxima implicación: atención 1 a 1 directa, plan 100% individualizado, seguimiento
          semanal y acceso personal a mí hasta conseguir el físico que buscas.
        </p>
        <CalendlyButton testid="rnb-calendly-open-button" className="mt-9">RESERVAR LLAMADA VIP</CalendlyButton>
      </Reveal>

      <div className="mt-16 lg:mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {INCLUDES.map((item, i) => (
          <Reveal key={item.title} delay={0.05 + i * 0.05} className="h-full">
            <div className="group h-full border border-zinc-800/80 bg-[#0D0D0D] p-7 transition-colors duration-300 hover:border-zinc-500">
              <item.icon className="h-6 w-6 text-zinc-500 group-hover:text-white transition-colors" />
              <h3 className="mt-6 font-display text-2xl tracking-wide text-white">{item.title}</h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{item.text}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="relative mt-16 lg:mt-24 overflow-hidden">
        <img
          src={IMAGES.editorial.victory}
          alt=""
          aria-hidden="true"
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover object-[center_20%]"
        />
        <div className="absolute inset-0 bg-black/75" aria-hidden="true" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#080808]/70 via-transparent to-[#080808]/70" aria-hidden="true" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14 lg:py-20">
          <Reveal className="text-center">
            <p className="text-xs tracking-[0.4em] text-zinc-400 uppercase">Paso a paso</p>
            <h3 className="mt-4 font-display text-3xl sm:text-4xl lg:text-5xl text-white leading-[0.95]">
              EMPEZAR ES MUY SENCILLO
            </h3>
          </Reveal>
          <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-5">
            {STEPS.map((s, i) => (
              <Reveal key={s.num} delay={0.05 + i * 0.08} className="h-full">
                <div className="h-full border border-zinc-700/70 bg-[#0D0D0D]/80 backdrop-blur-sm p-8">
                  <span className="font-display text-6xl text-zinc-700">{s.num}</span>
                  <h3 className="mt-6 font-display text-2xl tracking-wide text-white">{s.title}</h3>
                  <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{s.text}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2} className="mt-14 text-center">
            <p className="text-sm sm:text-base text-zinc-300 font-light max-w-xl mx-auto leading-relaxed">
              Sin precios cerrados en la web: primero hablamos, vemos tu caso y te digo exactamente cómo puedo ayudarte.
            </p>
            <CalendlyButton testid="rnb-calendly-open-button-bottom" className="mt-8">QUIERO MI LLAMADA DE ACCESO</CalendlyButton>
          </Reveal>
        </div>
      </div>
    </div>
  </section>
);

export default CoachingVipSection;
